import {
  BulkLoadedType,
  BulkRemoveType,
  ErrorType,
  InvalidateType,
  LoadedMoreType,
  LoadedType,
  type QueryParams,
  RequestMoreType,
  RequestType,
} from 'common/actions/usersForCompanyQueries';

import queryReducerFactory, { type QueriesState, type QueryState } from './queryReducerFactory';

import type { CompanyUser } from 'common/api/endpoints/users';

export type UsersForCompanyQueriesState = QueriesState<CompanyUser, QueryParams>;
export type UsersForCompanyQueryState = QueryState<CompanyUser, QueryParams> | undefined;

export { defaultState } from './queryReducerFactory';

const reducer = queryReducerFactory<CompanyUser, QueryParams>({
  bulkLoadedType: BulkLoadedType,
  bulkRemoveType: BulkRemoveType,
  errorType: ErrorType,
  invalidateType: InvalidateType,
  loadedMoreType: LoadedMoreType,
  loadedType: LoadedType,
  requestMoreType: RequestMoreType,
  requestType: RequestType,
  uniqueKey: '_id',
});

export default reducer;
